import {SAFire} from './safire.js';
import {Templates} from './Templates.js';

export class SACodeDetails extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = Templates("SACodeDetails");
		this.attachShadow({mode:"open"});
		this.shadowRoot.appendChild(this.el);
	}
	connectedCallback() {
		document.body.addEventListener('safire-sacode-click', evt=>this.detailsEvent(evt));
		this.detailsEvent({
			"detail": {
				"sacode": exampleCode,
			}
		});
	}
	detailsEvent(evt) {		
		const code = evt.detail.sacode;
		this.code = code;
		if (this.$.display.setSACode) {
			this.$.display.setSACode(code);
		} else {
			this.$.display.addEventListener(`safire-sacode-display-connected`, evt=>{
				this.$.display.setSACode(code);
			}, {'once':true});
		}
		// @TODO Need version and namespace support for SCC call
		SAFire.API().SCC(null, null, code.scc).then(
			scc => {
				if (scc.code != this.code.scc) {
					// we selected a new code while waiting for this code to load
					return;
				}
				if (scc.namespace.name=="epa.gov") {
					const a = document.createElement(`a`);
					a.innerText = scc.code;
					a.setAttribute(`href`,`https://cfpub.epa.gov/webfire/efwebservices/efwebsrv5.cfc?method=getEFData&SCC=${encodeURIComponent(scc.code)}`)
					a.setAttribute(`target`,`_blank`);
					this.$.scc_code.innerText =``;
					this.$.scc_code.appendChild(a)
				} else {
					this.$.scc_code.innerText = scc.code;
				}
				this.$.scc_namespace.innerText = scc.namespace.name;
				let el = this.$.factors.firstElementChild;
				while (el.nextSibling) el.nextSibling.remove();
				scc.factors.forEach(f => {
					const [el,$]=  Templates('SACodeDetails.factor');
					if (f.pollutant.cas) {
						const a = document.createElement(`a`);
						a.innerText = f.pollutant.pollutant;
						a.setAttribute('href', `https://www.wolframalpha.com/input?i=chemical+compound+cas+${encodeURIComponent(f.pollutant.cas)}`)
						//https://commonchemistry.cas.org/detail?cas_rn=${f.pollutant.cas}`)
						a.setAttribute('target','_blank');
						$.pollutant.innerText=``;
						$.pollutant.appendChild(a);
					} else {
						$.pollutant.innerText = f.pollutant.pollutant;
					}
					$.type.innerText = f.factor_type;
					$.formula.innerText = f.formula;
					$.factor.innerText = f.factor;
					$.exponent.innerText = f.exponent;
					$.unit.innerText = `${f.numerator_unit}/${f.denominator_unit}`
					$.quality.innerText = f.quality;
					$.citation.innerText = f.citation ? f.citation : f.reference;
					this.$.factors.lastChild.after(el);
				});
			});
		this.$.sa_code.innerText = code.code;
		// this.$.sa_full.innerText=  code.fullname;
		this.$.namespace.innerText = code.namespace;
	}
}

customElements.define(`safire-sacode-details`, SACodeDetails);

const exampleCode = {
  "id": 20999,
  "name": "Biomass - Agricultural Residue (Open)",
  "fullname": "Biomass Burning:Agricultural:Agricultural - Early Season - Agricultural Residue (open):Biomass - Agricultural Residue (Open)",
	"fullname_parts": ["Biomass Burning","Agricultural","Agricultural - Early Season - Agricultural Residue (open)","Biomass - Agricultural Residue (Open)",],
  "code": "SA240200115",
  "scc": "SA240200115",
  "namespace": "nei.dffe.gov.za",
  "parent": "SA2402001",
  "level": 3
};